import { PublicationService } from '../../../../graphql/services/publication.service';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import {
  DEAFULT_IMAGE_PUBLICATION,
  DEAFULT_SHIELD_COMPETITION,
  DEAFULT_SHIELD_TEAM,
  TYPE_COMPETITION_TEAM,
} from '../../../constants';
import { SharedService } from '../../../services/shared.service';
import { PublicationState } from '../../../../redux/state/publication.state';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
  GetMorePublicPublications,
  GetPublicPublications,
} from 'app/redux/actions/publication.actions';

import { Observable } from 'rxjs';
import { DEAFULT_IMAGE_ENTITY } from '@shared/constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EntityState } from 'app/redux/state/entity.state';
import { Entity } from 'app/graphql/interfaces/entityModel';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TypeService } from 'app/graphql/services/type.service';
import { Publication } from 'app/graphql/types';

@UntilDestroy()
@Component({
  selector: 'app-publication-tile',
  styleUrls: ['./publication-tile.component.scss'],
  templateUrl: './publication-tile.component.html',
})
export class PublicationTileComponent implements OnInit {
  @Input() publication: Publication;
  @Input() first: Boolean;
  @Input() widget: Boolean;
  @Input() simple: Boolean;

  body = null;
  defaultImagePublication = DEAFULT_IMAGE_PUBLICATION;
  defaultShieldCompetition = DEAFULT_SHIELD_COMPETITION;
  TYPE_COMPETITION_TEAM = TYPE_COMPETITION_TEAM;
  defaultShieldTeam = DEAFULT_SHIELD_TEAM;
  entity: Entity = this.store.snapshot().Entity.entity;

  options: any[] = [];

  social: any;

  constructor(
    private store: Store,
    public sharedService: SharedService,
    public translate: TranslateService,
    public typeService: TypeService,
    private publicationService: PublicationService,
    private http: HttpClient,
    private titleService: Title,
    private metaService: Meta,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.social =
      this.publication.socialTypeId != null
        ? this.typeService.getType(this.publication.socialTypeId)
        : null;
    if (this.social != null && this.social.langKey != null)
      this.social = { ...this.social, icon: this.typeService.getIcon(this.social.langKey) };
  }

  getPlainText(html: string): string {
    // Usar expresión regular para eliminar todas las etiquetas HTML
    const plainText = html.replace(/<\/?[^>]+(>|$)/g, '');
    // Limitar a 150 caracteres, por ejemplo
    return plainText.length > 150 ? plainText.substring(0, 150) + '...' : plainText;
  }
}
